import { create } from 'zustand';

export const useErrorStore = create((set) => ({
  error: null,
  isErrorLocked: false,

  setErrorMessage: (message, options = {}) => set((state) => {
    if (state.isErrorLocked && !options.force) {
      return state;
    }

    return {
      error: message,
      isErrorLocked: Boolean(options.lock),
    };
  }),
  clearError: () => set({ error: null, isErrorLocked: false }),
}));
